import { render, staticRenderFns } from "./TemplateTableFields.vue?vue&type=template&id=40788db4"
import script from "./TemplateTableFields.vue?vue&type=script&lang=js"
export * from "./TemplateTableFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports